<template>
    <div class="modal fade giftModal show">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <h4 class="mb-0 p-3">{{$t('declaration.text1')}} </h4>
                <div class="modal-body p-3">
                    <div class="d-flex align-items-center">
                        <div class="content">
                            <h4 class="mb-2">{{$t('riskWarning.text2')}} {{ store.customerDetail?.firstName || '' }},</h4>
                            <p>{{$t('riskWarning.text1')}} <a class="primary" href="https://fxview.com/global/static/fxview/pdf/legal-document/Risk-Disclosure-And-Warnings-Notice.pdf" target="_blank">{{$t('riskWarning.text3')}}</a> {{$t('riskWarning.text4')}}</p>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-4">
                        <div>
                            <label class="customCheckBox mb-3">
                                <span class="d-flex align-items-center">{{$t('declaration.text2')}}</span>
                                <input type="checkbox" class="form-control" name="accepted" v-model="accepted" true-value="true" false-value="false" @input="rejected = false" />
                                <span class="checkmark"></span>
                            </label>
                            <div class="mt-2">
                                <button type="button" class="grd_btn py-2" :class="[{'disabled' : !accepted || rejected }]" @click="submit()">{{$t('declaration.text3')}}</button>
                            </div>
                        </div>
                        <div>
                            <label class="customCheckBox mb-3">
                                <span class="d-flex align-items-center">{{$t('declaration.text4')}}</span>
                                <input type="checkbox" class="form-control" name="rejected" v-model="rejected" true-value="true" false-value="false" @input="accepted = false" />
                                <span class="checkmark"></span>
                            </label>
                            <div class="mt-2">
                                <button type="button" class="grd_btn py-2" :class="[{'disabled' : accepted || !rejected }]" @click="submit()">{{$t('declaration.text5')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useMainStore } from "@/store";
    export default{
        setup() {
            const store = useMainStore();
            return { store };
        },
        data(){
            return {
                accepted: false,
				rejected: false,

            }
        },
        methods:{
            submit(){
                if(this.accepted == this.rejected){
                    return
                }else{
                    let form = {
                        'risk_warning' : this.accepted ? 1 : 2
                    }
                    this.store.riskWarningStep(form,true,this.$route.params.id).then((response) =>{
                        if(response === true){
                            this.$parent.showRisk = false
                            this.$parent.getCurrentStatus()
                        }
                    })
                }
            }
        }
    }
</script>